<template>
  <a @click="openPlace" class="block bg-white mr-4 border border-section_border rounded p-2 w-48 overflow-hidden">
    <img v-lazy="place.image" class="w-full h-28" />
    <h2 class="mt-2 text-sm font-bold truncate">{{ place.name }}</h2>
  </a>
</template>

<script>
export default {
  props: {
    place: {
      type: Object
    }
  },
  methods: {
    openPlace: function () {
      this.$gtag.event("POI詳細表示", {
        poi_id: this.place.id,
        poi_name: this.place.name
      });
      this.$store.dispatch('drawer/openPlace', { place: this.place, full: true })
    }
  }
}
</script>
